enum ETaxCalculation {
  INCLUSIVE = 'inclusive',
  EXCLUSIVE = 'exclusive',
}

export default ETaxCalculation;
